import { couponConstants } from '../constants';
import { AuthActions } from './';
import { CouponApi } from '../services';

export class CouponActions {
    static create (data) {
        return (dispatch) => {
            dispatch({type: couponConstants.CREATE_COUPON_REQUEST});

            CouponApi.create(data)
                .then(AuthActions.ok(dispatch))
                .then((res) => {
                    // success
                    if(res.meta.success === true && res.data) {
                        dispatch({type: couponConstants.CREATE_COUPON_SUCCESS, payload: {...data, ...res.data}});
                        return;
                    }

                    return dispatch({type: couponConstants.CREATE_COUPON_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: couponConstants.CREATE_COUPON_FAILURE});
                });
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/coupon.js